<div id="wealthHomeWalkThrough"></div>

<div
  class="w-100"
  id="header-transactions"
>
  <ngx-app-bar
    class="w-100 d-block surface-back"
    [title]="'مدیریت ثروت'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
    [leftButton]="{ mode: 'icon-only', size: 'small', icon: { name: 'person', type: 'bold' } }"
    (onLeftButtonClick)="goToProfile()"
    [leftIcon]="{
      name: 'card-to-card',
      type: 'bold',
    }"
    (onLeftIconClick)="goToTransactions()"
  />
</div>

<div class="px-plus mt-minus">
  <div id="wealth-assets">
    <wealth-applet-home-assets
      class="d-flex position-relative"
      [portfolio]="assetData()"
      [isLoadingNewData]="isLoadingNewData()"
      [isLoading]="loadingAssets()"
      (handleUpdateData)="getUpdatedAssets()"
    />
  </div>
  <wealth-applet-home-banner [banners]="isWebsite() ? wealthBanner() : dpBanners()" />
</div>
@if (isWebsite()) {
  <div class="d-flex px-plus">
    <wealth-applet-home-banner [banners]="wealthSecondBanner()" />
  </div>
} @else {
  <div
    class="d-flex flex-wrap px-plus"
    id="wealth-dashboard-categories"
  >
    <div [ngClass]="{ 'text-oninvert-high': walkThroughService.isWorking }">
      <span class="st-8 text-onback-medium"> دسته‌بندی‌های سرمایه‌گذاری </span>
    </div>
    @if (ipoBanner()) {
      <wealth-applet-ipo-banner
        class="w-100 d-flex mt-minus"
        [banner]="ipoBanner()"
      />
    }
    @if (campaignBanner()?.length) {
      <div class="campaign-banner">
        @for (banner of campaignBanner(); track $index) {
          <img
            src="wealth-assets/images/treasure-hunt-banner.png"
            width="100%"
            height="100%"
            alt="campaign-banner"
            (click)="onCampaignBannerClick(banner)"
          />
        }
      </div>
    }

    <wealth-applet-home-categories
      class="w-100 mt-minus"
      [categories]="dpSecondBanners()"
    />
  </div>
}

<div
  id="wealth-dashboard-news"
  class="mt-big"
>
  <wealth-applet-home-news />
</div>
